/**
 * Date source abstraction for the application.
 * 
 * This module provides a way to switch between real current date (production)
 * and a fixed development date based on environment configuration.
 * All parts of the application should use this service to get the current date.
 */

import { DateTime } from 'luxon';
import { DEV_BASE_DATE } from './devDate';
import { salonNow } from './time';

export interface DateSource {
  now(): DateTime;
}

class ProdDateSource implements DateSource {
  now(): DateTime {
    return salonNow();
  }
}

class DevDateSource implements DateSource {
  now(): DateTime {
    return DateTime.fromISO(DEV_BASE_DATE, { zone: 'UTC' });
  }
}

export const dateSource: DateSource = new ProdDateSource(); // Default to production date. Adjust this logic if environment variable access is needed for development mode.
